import React from "react";
import { RegistryConfirmationData } from "./RegistryConfirmationData";
import QRCode from "qrcode.react";

import { calcularEdad } from "../../../../../services/utils";
import OxxoPaymentCode from "./OxxoPaymentCode";
import CardPaymentPromissoryNote from "./CardPaymentPromissoryNote";
import DetailOrderConfirmation from "./DetailOrderConfirmation";
import DisclaimerResponsabilitiesHTML from "../DisclaimerResponsabilities/DisclaimerResponsabilitiesHTML";
import jsPDF from "jspdf";
import PhotoEditorDefault from "../../../Athletes/VirtualEvents/PhotoEditorVirtual/PhotoEditorDefault";
import { Button, DialogContentText, Typography } from "@material-ui/core";
import RegistryConfirmationPdfPreview from "../../../../OrganizerWeb/sections/EventRegistry/RegistryConfirmation/RegistryConfirmationPdfPreview";

class RegistryConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: this.props.tipo,
      update: true,
    };
  }

  // { registryParticipantDataConfirm,
  //   registryParticipantKeyConfirm,
  //   eventDetail,
  //   eventSubEvents,
  //   registryConfiguration,
  //   tipo,
  //   reference,
  //   codigoSuscripcion }) => {


  render() {
    var jsonMail = {};
    jsonMail.inscritoKey = this.props.registryParticipantKeyConfirm;
    jsonMail.eventoIndex = "evento_" + this.props.eventDetail.iDEvento;

    jsonMail.detalleEvento = this.props.eventDetail;
    jsonMail.datos = this.props.registryParticipantDataConfirm;
    jsonMail.modalidades = this.props.eventSubEvents;
    console.log(this.props.eventSubEvents);
    jsonMail.inscripcionesConfiguracion = this.props.registryConfiguration;

    var color = "#000000";
    if (jsonMail.detalleEvento.organizador.colorOrganizador != undefined) {
      color = jsonMail.detalleEvento.organizador.colorOrganizador;
    }
    var numero = 0;
    if (jsonMail.datos.numero != undefined) {
      numero = jsonMail.datos.numero;
    }
    var distancia = 0;
    var modIndex = "modalidad_" + jsonMail.datos.modalidad;
    if (jsonMail.datos.modalidad != undefined) {
      distancia = jsonMail.modalidades[modIndex].descripcionModalidad;
    }
    var rama = 0;
    var ramaIndex;
    if (jsonMail.datos.rama != undefined) {
      ramaIndex = "rama_" + jsonMail.datos.rama;
      rama = jsonMail.datos.rama;
    }
    var categoriaJson;
    var categoria;
    var categoriaIndex;
    if (jsonMail.datos.categoria != undefined) {
      categoriaIndex = "categoria_" + jsonMail.datos.categoria;
      categoriaJson =
        jsonMail.modalidades[modIndex].ramaCat[ramaIndex].categorias[
        categoriaIndex
        ];
      categoria = categoriaJson.nombreCategoria;
    }

    // tipo 0 = es que no se muestra la confirmacion todavia
    // tipo 1 = solo confirmacion aplica para pago en efectivo y tarjeta de credito aprobada
    // tipo 2 = registro y ficha de pago
    // tipo 3 = confirmacion de inscripcion y pago recibido en oxxo

    var idioma = "es";

    var jsonTextos = RegistryConfirmationData;

    var edad = calcularEdad(
      jsonMail.datos.fechaNacimiento,
      jsonMail.detalleEvento.fechaEvento,
      true
    );


    var fichaDePago;
    if (this.state.tipo == 2) {
      fichaDePago = (
        <OxxoPaymentCode
          jsonMail={jsonMail}
          jsonTextos={jsonTextos}
          idioma={idioma}
          reference={this.props.oxxoReference}
          tipo={this.state.tipo}
        />
      );
    }
    var detalleOrden = (
      <DetailOrderConfirmation
        jsonMail={jsonMail}
        jsonTextos={jsonTextos}
        idioma={idioma}
        reference={this.props.oxxoReference}
        tipo={this.state.tipo}
      />
    );

    var nombresYApellidos = "";
    if (this.state.tipo == 4) {
      nombresYApellidos = this.props.codigoSuscripcion;
    } else {
      nombresYApellidos =
        jsonMail.datos.nombres + " " + jsonMail.datos.apellidos;
    }

    if (this.state.tipo == 0) {
      return <h5>Confirmación pendiente</h5>;
    }

    console.log("jsonMail", jsonMail);


    return (
      <div>
        <div className="row">
          <div className="col s12 center-align">
            {jsonTextos[idioma].preNombre[this.state.tipo]}
          </div>
          <div className="col s12">
            <h4 className="center-align">{nombresYApellidos}</h4>
          </div>
          <div className="col s12 center-align">
            {jsonTextos[idioma].postNombre[this.state.tipo]}
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <h3 className="center-align">
              {jsonMail.detalleEvento.nombreEvento}
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col s6 offset-s3">
            <img
              alt="logo Evento"
              title="logo Evento"
              src={jsonMail.detalleEvento.logoEvento}
              style={{
                border: "none",
                borderRadius: "0px",
                display: "block",
                fontSize: "13px",
                outline: "none",
                textDecoration: "none",
                width: "100%",
              }}
              width={212}
            />
          </div>
        </div>

        <RegistryConfirmationPdfPreview
          title="Deslinde de responsabilidades"
          jsonMail={jsonMail}
          qrElementId="qrSeguimiento"
          dorsalElementId="dorsalPreviewCanvas"
          height={500}
          maxWidth={850}
          delay={1500}
          refreshKey={`${jsonMail.inscritoKey}-${this.state.tipo}-${jsonMail.datos.numero}`}
        />



        <hr />
        {jsonMail.inscripcionesConfiguracion.configuracion.dorsal &&
          numero > 0 && (
            <div className="row">
              <div className="col s12">
                <h2 className="center-align">Dorsal digital</h2>
              </div>
              <div id="dorsalPreviewCanvas" className="center-align col s12 m12">
                <PhotoEditorDefault
                  size="80%"
                  participant={{
                    raceNumber: numero,
                    athleteName: jsonMail.datos.nombres,
                    athleteLastName: jsonMail.datos.apellidos,
                  }}
                  currentEvent={{
                    distance: 10,
                    raceNumberFontColor:
                      jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                        .raceNumberFontColor,
                    raceNumberWhiteBack:
                      jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                        .raceNumberWhiteBack,
                    raceNumberVertical: jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                      .raceNumberVertical || 1

                  }}
                  urlPhoto={
                    jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                      .raceNumberImage
                  }
                  type={"raceNumber"}
                />
              </div>
            </div>
          )}

        <div className="row">
          <div className="col s12">
            <h5 className="center-align">
              {jsonTextos[idioma].LinkYQRSeguimiento}
            </h5>
          </div>
          <div className="col s12 m12 center-align">
            <QRCode
              id="qrSeguimiento"
              value={
                jsonMail.inscripcionesConfiguracion.configuracion
                  .rutaDetalleInscrito +
                "?event=" +
                jsonMail.eventoIndex +
                "&registry=" +
                jsonMail.inscritoKey +
                "&download=true"
              }
            />
          </div>
          <div className="col s12 m12 center-align">
            <Typography
              color="primary"
              gutterBottom
              variant={"h5"}
              component="h2"
            >
              <a
                target="_blank"
                href={`${jsonMail.inscripcionesConfiguracion.configuracion.rutaDetalleInscrito}?event=${jsonMail.eventoIndex}&registry=${jsonMail.inscritoKey}&download=true`}
              >
                {jsonMail.inscripcionesConfiguracion.configuracion
                  .rutaDetalleInscrito +
                  "?event=" +
                  jsonMail.eventoIndex +
                  "&registry=" +
                  jsonMail.inscritoKey +
                  "&download=true"}
              </a>
            </Typography>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col s6 offset-s3"></div>
        </div>
        <div className="row">
          <div className="col s12">
            <h5 className="center-align">{jsonTextos[idioma].tituloDatos}</h5>
          </div>
          <div className="col s3 center-align">
            <b className="center-align">{jsonTextos[idioma].Numero}</b>
            <br />
            {numero}
          </div>
          <div className="col s3  center-align">
            <b className="center-align">{jsonTextos[idioma].Distancia}</b>
            <br />
            {distancia}
          </div>
          <div className="col s3  center-align">
            <b className="center-align">{jsonTextos[idioma].Rama}</b>
            <br />
            {rama}
          </div>
          <div className="col s3 center-align">
            <b>{jsonTextos[idioma].Categoria}</b>
            <br />
            {categoria}
          </div>
        </div>
        {detalleOrden}
        {fichaDePago}
        <footer />
      </div>
    );
  }
}

export default RegistryConfirmation;
